module.exports = __webpack_public_path__ + "img/donateQRcode.080178fa.jpeg";